<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
import useFetch from './main-state';

const props = defineProps({
  endpoint: {
    type: String,
    require: true,
    default() {
      return '';
    },
  },
  paginate: {
    type: Boolean,
    require: false,
    default() {
      return true;
    },
  },
  onMount: {
    type: Boolean,
    require: false,
    default() {
      return true;
    },
  },
  filterObj: {
    type: Object,
    require: false,
    default() {
      return {};
    },
  },
  hitByPage: {
    type: Number,
    require: false,
    default() {
      return 8;
    },
  },
  analitycs: {
    type: Object || null,
    required: false,
    default() {
      return null;
    },
  },
});

const core = useFetch(
  props.endpoint,
  props.filterObj,
  props.onMount,
  props.hitByPage,
  props.analitycs,
);

const {
  listItems,
  restFromResponse,
  isLoading,
  currentPage,
  availableFilters,
  firstLoad,
  onFilterChanged,
  pageChangedHanlder,
  clearQueryFilter,
} = core;
</script>

<template>
  <div>
    <slot
      v-if="props.filterObj"
      name="filters"
      :on-filter-changed="onFilterChanged"
      :clear-query-filter="clearQueryFilter"
      :available-filters="availableFilters"
      :list-items="listItems"
      :first-load="firstLoad"
      :rest-from-response="restFromResponse"
    />

    <slot
      v-if="restFromResponse?.spellSuggestions"
      name="spellSugesstions"
      :spell-suggestions="restFromResponse?.spellSuggestions"
    />

    <slot
      v-if="listItems"
      :list-items="listItems"
      :rest-from-response="restFromResponse"
      :is-loading="isLoading"
      :spell-suggestions="restFromResponse?.spellSuggestions"
      :total-items="restFromResponse?.totalItems || restFromResponse.total"
    />

    <no-results
      v-if="listItems"
      :list="listItems"
      :total-items="restFromResponse?.totalItems || restFromResponse?.total"
    />

    <pagination
      v-if="paginate &&
        (restFromResponse?.totalItems || restFromResponse?.total)
        > (restFromResponse?.itemsPerPage || 8)
        && listItems?.length > 0"
      :total-items="(restFromResponse?.totalItems || restFromResponse?.total)"
      :current-page="currentPage || 1"
      :per-page="restFromResponse?.itemsPerPage || restFromResponse?.query?.pageSize || 8"
      @page-changed="pageChangedHanlder"
    />
  </div>
</template>
